import * as React from 'react';
import {useHistory} from 'src/rerouter';
import {createPortal} from 'react-dom';


export type PortalToAskAiProps = {
  id?: string;
  children: React.ReactNode;
};

export const PortalToAskAi = ({children}: PortalToAskAiProps) => {
  const history = useHistory();
  const isFullscreen = history.location.query?.fscr === 'true';
  const [target, setTarget] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    if (!isFullscreen || typeof document === 'undefined') {
      setTarget(null);
      return;
    }
    const query = `[data-askai-fullscreen-portal-target="askai-fullscreen-portal"]`;
    const find = () => {
      setTarget(document.querySelector(query) as HTMLElement | null);
    };

    find();
    const observer = new MutationObserver(find);
    observer.observe(document.body, {childList: true, subtree: true});
    return () => observer.disconnect();
  }, [isFullscreen]);

  if (!isFullscreen) {
    return <>{children}</>;
  }
  if (!target) {
    return null;
  }
  return createPortal(children, target);
};
